'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var IconButton = _interopDefault(require('@material-ui/core/IconButton'));
var CloseIcon = _interopDefault(require('@material-ui/icons/Close'));

var DefaultAction = function (props) {
    var onClose = props.onClose;
    return (React__default.createElement(IconButton, { "data-testid": 'alert-banner-default-action', "aria-label": 'close', color: 'inherit', size: 'medium', onClick: onClose, style: { padding: '0.1rem' } },
        React__default.createElement(CloseIcon, { fontSize: 'inherit' })));
};

module.exports = DefaultAction;
